import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { exportProjectReport } from './actions/export-report-project.action';

export type ProjectMode = 'festival' | 'venue' | 'tour';

export type ProjectState = {
  mode: ProjectMode;
  isExportingReport: boolean;
};

const initialState: ProjectState = {
  mode: 'festival',
  isExportingReport: false,
};

export const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    changeMode(state, action: PayloadAction<ProjectMode>) {
      state.mode = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      // exportProjectReport
      .addCase(exportProjectReport.pending, (state) => {
        state.isExportingReport = true;
      })
      .addCase(exportProjectReport.fulfilled, (state) => {
        state.isExportingReport = false;
      })
      .addCase(exportProjectReport.rejected, (state) => {
        state.isExportingReport = false;
      });
  },
});
